const tableCols = [
    {
        field: 'CT1_NEW',
        header: 'New',
        visible: true,
        filter: true,
        sort: true,
        tooltip: 'Is New',
        export: {visible: true, checked: true},
        width: 3
    },
    {
        field: 'CT1_TAG_ID',
        header: 'Tag ID',
        visible: true,
        filter: true,
        sort: true,
        tooltip: 'Tag ID',
        export: {visible: true, checked: true},
        width: 15
    },
    {
        field: 'CT1_TAG_NAME',
        header: 'Tag Name',
        visible: true,
        filter: true,
        sort: true,
        tooltip: 'Tag Name',
        export: {visible: true, checked: true},
        width: 30
    },
    {
        field: 'CT1_CO1_ID',
        header: 'Company ID',
        visible: true,
        filter: true,
        sort: true,
        tooltip: 'Company ID',
        export: {visible: true, checked: true},
        width: 15
    },
    {
        field : 'CT1_CO1_NAME',
        header : 'Company Name',
        visible : true,
        filter : true,
        sort : true,
        tooltip : 'Company Name',
        export : { visible : true, checked : true },
        width : 30
    },
    {
        field: 'CT1_MODIFIED_ON',
        header: 'Last Modified On',
        visible: true,
        filter: false,
        sort: true,
        tooltip: 'Last Modified On',
        export: {visible: true, checked: true},
        width: 30
    },
    {
        field: 'CT1_CREATED_ON',
        header: 'Created On',
        visible: true,
        filter: false,
        sort: true,
        tooltip: 'Created On',
        export: {visible: true, checked: true},
        width: 30
    },
    {
        field: 'ACTIONS',
        header: 'Actions',
        visible: true,
        filter: false,
        sort: false,
        tooltip: 'Actions',
        export: {visible: false, checked: false},
        width: 30
    }
];
export default tableCols;



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/teamwork-reports/company-mapping/company-mapping.cols.ts